import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay for better UX
      setTimeout(() => setIsVisible(true), 500);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
    // Enable analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
    // Disable analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__content">
        <div className="cookie-consent__icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <circle cx="8" cy="10" r="1.5" fill="currentColor"/>
            <circle cx="15" cy="9" r="1" fill="currentColor"/>
            <circle cx="10" cy="15" r="1" fill="currentColor"/>
            <circle cx="16" cy="14" r="1.5" fill="currentColor"/>
            <circle cx="12" cy="11" r="1" fill="currentColor"/>
          </svg>
        </div>
        <div className="cookie-consent__text">
          <h3>{t('cookieConsent.title')}</h3>
          <p>
            {t('cookieConsent.message').replace('cookiebeleid', '').replace('cookie policy', '').trim()}{' '}
            <Link to="/cookies">{t('cookieConsent.cookiePolicy')}</Link>.
          </p>
        </div>
      </div>
      <div className="cookie-consent__actions">
        <button 
          className="cookie-consent__btn cookie-consent__btn--secondary"
          onClick={acceptNecessary}
        >
          {t('cookieConsent.necessary')}
        </button>
        <button 
          className="cookie-consent__btn cookie-consent__btn--primary"
          onClick={acceptAll}
        >
          {t('cookieConsent.acceptAll')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;

